import { render, staticRenderFns } from "./DesktopWidget.vue?vue&type=template&id=2601245c"
import script from "./DesktopWidget.vue?vue&type=script&lang=js"
export * from "./DesktopWidget.vue?vue&type=script&lang=js"
import style0 from "./DesktopWidget.vue?vue&type=style&index=0&id=2601245c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports